module.exports = __webpack_public_path__ + "img/thunderstorm.3c3cf720.svg";